module.exports = __webpack_public_path__ + "videos/video-preview-lanscape.ef55023c725485e9a2a0e3cc2ef79c8f.mp4";


//////////////////
// WEBPACK FOOTER
// ./images/video-preview-lanscape.mp4
// module id = 712
// module chunks = 0